import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b0d1943"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-insurance__section" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col--12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "xhtml" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Tailored Travel Insurance Options, from the Island's Travel Specialists"),
    /*#__PURE__*/_createElementVNode("p", null, "Like any offshore destination, travel to the Isles of Scilly can occasionally be delayed by bad weather and other eventualities. The insurance we offer may cover these eventualities and offer 2 insurance policies that are tailor made for travel to the Isles of Scilly. For full terms and conditions, please read the policy documents."),
    /*#__PURE__*/_createElementVNode("h4", null, "Insurance is only valid for UK residents with a UK address"),
    /*#__PURE__*/_createElementVNode("p", null, "You must be a full UK resident who is staying in or has lived in the United Kingdom for more than 12 months, if studying or working in the United Kingdom for more than 6 months."),
    /*#__PURE__*/_createElementVNode("p", null, "The maximum excess payable is £40 per person or £80 per family."),
    /*#__PURE__*/_createElementVNode("p", null, "Isles of Scilly Steamship Company Limited trading as Isles of Scilly Travel is an Appointed Representative of ITC Compliance Limited which is authorised and regulated by the Financial Conduct Authority (their registration number is 313486) and which is permitted to advise on and arrange general insurance contracts.")
  ])
], -1))
const _hoisted_4 = { class: "col--12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Do you need insurance?", -1))
const _hoisted_6 = {
  key: 0,
  class: "col--12 input-field__error"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "checkout-insurance__section" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col--12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "xhtml" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Before we go further"),
    /*#__PURE__*/_createElementVNode("p", null, " For your protection our insurance products are regulated by the Finance Conduct Authority. Isles of Scilly Steamship Company Limited T/a Isles of Scilly Travel are an Appointed Representative of ITC Complicance Ltd for the sale of General Insurance, who are fully authorized by the Financial Conduct Authority. You will not receive advice or a recommendation from us for insurance; however, we will provide factual information regarding the product for you to make your own informed decision. ")
  ])
], -1))
const _hoisted_11 = { class: "col--12" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Please confirm that you want to proceed with the quote", -1))
const _hoisted_13 = {
  key: 0,
  class: "input-field__error"
}
const _hoisted_14 = { class: "checkout-insurance__section" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col--12" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Please select the appropriate policy for your needs:")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Travel Insurance", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Includes"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Delayed departures"),
    /*#__PURE__*/_createElementVNode("li", null, "Missed departures"),
    /*#__PURE__*/_createElementVNode("li", null, "Luggage delay"),
    /*#__PURE__*/_createElementVNode("li", null, "Luggage and personal money"),
    /*#__PURE__*/_createElementVNode("li", null, "Personal liability")
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Exclusions"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Cover is only available to United Kingdom residents."),
    /*#__PURE__*/_createElementVNode("li", null, "You are not required to declare your medical conditions. However, to be covered for these, you must be able to with the health declaration on page 1 of the policy terms and conditions."),
    /*#__PURE__*/_createElementVNode("li", null, "Valuables including your passport or visa if left unattended at any time."),
    /*#__PURE__*/_createElementVNode("li", null, "You are participating in professional or organised sport, winter sports."),
    /*#__PURE__*/_createElementVNode("li", null, "Your travel to a country or specific area or event to which the travel advice unit of the Foreign & Commonwealth Office (FCO) has adviced against.")
  ])
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Delay Insurance", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Includes"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Cover for one-way journeys"),
    /*#__PURE__*/_createElementVNode("li", null, "Delayed departures"),
    /*#__PURE__*/_createElementVNode("li", null, "Missed departures"),
    /*#__PURE__*/_createElementVNode("li", null, "Personal accident"),
    /*#__PURE__*/_createElementVNode("li", null, "Luggage and personal money")
  ])
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Exclusions"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Traveling against the advice of a medical practitioner."),
    /*#__PURE__*/_createElementVNode("li", null, "If you know you will need treatment during your trip, or you are traveling specifically to obtain treatment."),
    /*#__PURE__*/_createElementVNode("li", null, "Traveling with an existing medical condition as mentioned in the policy document."),
    /*#__PURE__*/_createElementVNode("li", null, "If you or anyone else named on this policy is not a resident in the UK.")
  ])
], -1))
const _hoisted_23 = { class: "col--12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseRadio = _resolveComponent("BaseRadio")!
  const _component_BaseExpansion = _resolveComponent("BaseExpansion")!
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_InsuranceOption = _resolveComponent("InsuranceOption")!
  const _component_ConfirmField = _resolveComponent("ConfirmField")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_BaseRadio, {
            id: "i-opt-1",
            name: "include",
            label: "Yes",
            value: true,
            modelValue: _ctx.v$.needInsurance.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.needInsurance.$model) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_BaseRadio, {
            id: "i-opt-2",
            name: "include",
            label: "No",
            value: false,
            modelValue: _ctx.v$.needInsurance.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.needInsurance.$model) = $event))
          }, null, 8, ["modelValue"])
        ]),
        (_ctx.v$.needInsurance.$errors.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.needInsurance.$errors, (error) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: error,
                  innerHTML: error.$message
                }, null, 8, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_BaseExpansion, {
      expanded: _ctx.v$.needInsurance.$model
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_BaseRadio, {
                id: "i-opt-3",
                name: "confirm",
                label: "Yes",
                value: true,
                modelValue: _ctx.v$.confirmInsurance.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.confirmInsurance.$model) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_BaseRadio, {
                id: "i-opt-4",
                name: "confirm",
                label: "No",
                value: false,
                modelValue: _ctx.v$.confirmInsurance.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.confirmInsurance.$model) = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.v$.confirmInsurance.$model === false)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, "By selecting no, we cannot quote or sell you travel insurance."))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["expanded"]),
    (_ctx.v$.needInsurance.$model)
      ? (_openBlock(), _createBlock(_component_BaseExpansion, {
          key: 0,
          expanded: _ctx.v$.needInsurance.$model && _ctx.v$.confirmInsurance.$model
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insurances, (insurance, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["col--12", { 'col-md--6': _ctx.insurances.length > 1 }]),
                    key: index
                  }, [
                    _createVNode(_component_InsuranceOption, {
                      passengers: insurance.passengers,
                      insuranceType: insurance.insuranceType,
                      documents: insurance.documents
                    }, {
                      default: _withCtx(() => [
                        (insurance.insuranceType === _ctx.ExtraTypeEnum[_ctx.ExtraTypeEnum.TravelInsurance])
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("header", null, [
                                _createVNode(_component_BaseSvg, { icon: 'account/avatar' }),
                                _hoisted_17,
                                _createElementVNode("h3", null, "from £" + _toDisplayString(insurance.totalPrice.toFixed(2)) + " (INC IPT at current rate)", 1)
                              ]),
                              _hoisted_18,
                              _hoisted_19
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("header", null, [
                                _createVNode(_component_BaseSvg, { icon: 'account/avatar' }),
                                _hoisted_20,
                                _createElementVNode("h3", null, "from £" + _toDisplayString(insurance.totalPrice.toFixed(2)) + " (INC IPT at current rate)", 1)
                              ]),
                              _hoisted_21,
                              _hoisted_22
                            ], 64))
                      ]),
                      _: 2
                    }, 1032, ["passengers", "insuranceType", "documents"])
                  ], 2))
                }), 128)),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.confirmFields, (type, index) => {
                    return (_openBlock(), _createBlock(_component_ConfirmField, {
                      key: index,
                      type: type,
                      secondType: type === _ctx.InsuranceConfirmationEnum.ForbiddenActivity ? _ctx.InsuranceConfirmationEnum.ForbiddenActivityConfirm : undefined
                    }, null, 8, ["type", "secondType"]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["expanded"]))
      : _createCommentVNode("", true)
  ], 64))
}